module.exports = __webpack_public_path__ + "img/4.00932ba3.png";